import React from 'react';
import { useOutletContext } from 'react-router-dom';

export default function TeacherLandingCourses() {
  const { content, openContact } = useOutletContext();
  const c = content.courses;

  return (
    <main>
      <section className="tl-course-hero">
        <div className="tl-wrap">
          <span className="tl-badge">{c.badge}</span>
          <h1 className="tl-serif tl-h1" style={{ marginTop: '1rem' }}>
            {c.title}
          </h1>
          <p className="tl-lead">{c.subhead}</p>
          <div className="tl-hero-actions">
            <button type="button" className="tl-btn tl-btn-primary" onClick={openContact}>
              {c.primaryCta} →
            </button>
          </div>
        </div>
      </section>

      <section className="tl-section tl-course-band">
        <div className="tl-wrap tl-course-list">
          {c.items.map((item) => (
            <article key={item.title} className="tl-course-item">
              <div className="tl-course-main">
                <span className="tl-badge">{item.badge}</span>
                <h3>{item.title}</h3>
                <p className="sub">{item.subtitle}</p>
                <p className="tl-lead" style={{ maxWidth: 'none' }}>
                  {item.body}
                </p>
                <ul className="tl-meta" style={{ marginTop: '0.85rem' }}>
                  {item.tags.map((t) => (
                    <li key={t}>{t}</li>
                  ))}
                </ul>
                <ul>
                  {item.bullets.map((b) => (
                    <li key={b}>{b}</li>
                  ))}
                </ul>
              </div>
              <div className="tl-course-side">
                <div className="price-label">{c.priceLabel}</div>
                <p className="price">{c.priceValue}</p>
                <p className="hint">{c.priceHint}</p>
                <div className="tl-offer-box">
                  <strong>{c.offerTitle}</strong>
                  <span>{c.offerBody}</span>
                </div>
                <button type="button" className="tl-btn tl-btn-primary" onClick={openContact}>
                  {c.bookCta}
                </button>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="tl-section tl-section-muted">
        <div className="tl-wrap">
          <p className="tl-eyebrow tl-center">{c.howEyebrow}</p>
          <h2 className="tl-serif tl-h2 tl-center">{c.howTitle}</h2>
          <div className="tl-steps">
            {c.howSteps.map((s) => (
              <article key={s.n} className="tl-step">
                <div className="n">{s.n}</div>
                <h3 className="tl-serif">{s.title}</h3>
                <p>{s.body}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="tl-section">
        <div className="tl-wrap">
          <p className="tl-eyebrow tl-center">{c.faqEyebrow}</p>
          <h2 className="tl-serif tl-h2 tl-center">{c.faqTitle}</h2>
          <div className="tl-faq">
            {c.faq.map((item) => (
              <article key={item.q} className="tl-faq-item">
                <h3>{item.q}</h3>
                <p>{item.a}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="tl-band">
        <div className="tl-wrap">
          <h2 className="tl-serif tl-h2">{c.bandTitle}</h2>
          <p>{c.bandBody}</p>
          <button type="button" className="tl-btn tl-btn-light" onClick={openContact}>
            {c.bandCta}
          </button>
        </div>
      </section>
    </main>
  );
}
